// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_Iab","cls2":"ReferenceReportPage-cls2_0o9 ReferenceReportPage-cls1_Iab"};